import {QueueAvatarProps} from './types'
import QueueAvatarView from './QueueAvatarView'
import React from 'react'

const QueueAvatar = (props: QueueAvatarProps): React.ReactElement => {
    const {
        closed = false,
        length = 0,
        name = undefined,
        size = undefined,
        unassigned_registered = undefined,
        isGroupQueue = false,
        groupQueues = [],
    } = props

    const showLetterAvatar = Boolean(length && length > 0)
    const letterHighlight = showLetterAvatar
    const letterLength = showLetterAvatar ? 3 : 1
    const letterName = showLetterAvatar ? String(length) : name
    const iconClosed = closed
    const iconHighlight = Boolean(unassigned_registered)
    const statusState = closed ? 'closed' : undefined

    return (
        <QueueAvatarView
            groupQueues={groupQueues}
            iconClosed={iconClosed}
            iconHighlight={iconHighlight}
            isGroupQueue={isGroupQueue}
            letterHighlight={letterHighlight}
            letterLength={letterLength}
            letterName={letterName}
            showLetterAvatar={showLetterAvatar}
            size={size}
            statusState={statusState}
        />
    )
}

export default QueueAvatar
